import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useLocation } from "react-router-dom";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import "./css/CopyPriceSchedule.css";
import { axios_helper_no_header } from "../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";

const CopyPriceSchedule = () => {
  const location = useLocation();
  const toast = useToast();
  const {
    selectedPriceSchedules,
    currentMode,
    currentIndex: initialIndex = 0,
  } = location.state || {};

  const navigateToPage = useCustomNavigate();
  const [parentPriceScheduleName, setParentPriceScheduleName] = useState("");
  const [parentPriceScheduleDescription, setParentPriceScheduleDescription] =
    useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({});

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [previouslyFetchedName, setPreviouslyFetchedName] = useState("");

  const handleReset = () => {
    reset();
  };

  const submitCopiedPriceSchedule = (data) => {
    axios_helper_no_header(
      "POST",
      "api/priceschedule/copy",
      { ...data, existingPriceScheduleName: parentPriceScheduleName },
      null
    )
      .then((response) => {
        console.log("Price schedule copied successfully");
        // Optionally, clear the form fields or show a success message
        handleReset();
        // Optionally, show a success message
        toast.current.show({
          severity: "success",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });

        setPreviouslyFetchedName(data.newPriceScheduleName);
        if (currentIndex < selectedPriceSchedules.length - 1) {
          setCurrentIndex(currentIndex + 1);
        } else {
          navigateToPage("/price-schedule", {
            priceSchedule: data.newPriceScheduleName,
          });
        }
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: error.message,
          life: 3000,
        });
        console.log(error);
      });
  };

  const fetchPriceScheduleData = (index) => {
    const priceScheduleName = selectedPriceSchedules[index];
    console.log(priceScheduleName);

    axios_helper_no_header("GET", "api/priceschedule/" + priceScheduleName)
      .then((response) => {
        console.log(response);
        const data = response.responseData;
        console.log("Inside try");

        // Update parent price schedule details
        setParentPriceScheduleName(data.priceScheduleName);
        console.log("Parent PRC", parentPriceScheduleDescription);
        setParentPriceScheduleDescription(data.description);
        handleReset();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (currentIndex < selectedPriceSchedules.length) {
      fetchPriceScheduleData(currentIndex);
    }
  }, [currentIndex]);

  const handleBack = () => {
    if (currentMode === "edit") {
      navigateToPage("/edit-price-schedule", {
        selectedPriceSchedules,
        currentMode,
        currentIndex,
      });
    } else {
      if (currentIndex < selectedPriceSchedules.length - 1) {
        setCurrentIndex(currentIndex + 1);
      } else {
        navigateToPage("/price-schedule", {
          priceSchedule: previouslyFetchedName,
        });
      }
    }
  };

  const keyFunc = {
    F12: handleBack,
  };

  const keyName = {
    F12: "\u2190 Back",
  };
  return (
    <form onSubmit={handleSubmit(submitCopiedPriceSchedule)}>
      <div className="grid">
        <div className="col col-10">
          {/* <button type="button" className="butfilter" onClick={handleBack}>
            Back
          </button> */}
          <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
        </div>
        <div className="col col-2">
          <Button label="Save" type="submit" />
        </div>
      </div>
      <div className="grid">
        <h1>
          Copy Price Schedule - <span className="heading-cod">RCPRC009</span>
        </h1>
      </div>

      <div className="grid">
        <h4>From:</h4>
      </div>
      <div className="grid">
        <div className="col col-4">
          <label htmlFor="parentPriceScheduleName">Schedule:</label>
        </div>
        <div className="col col-4">
          <p id="parentPriceScheduleName">{parentPriceScheduleName}</p>
        </div>
      </div>
      <div className="grid">
        <div className="col col-4">
          <label htmlFor="parentPriceScheduleDescription">Description::</label>
        </div>
        <div className="col col-4">
          <p id="parentPriceScheduleDescription">
            {parentPriceScheduleDescription}
          </p>
        </div>
      </div>
      <div className="grid">
        <h4>To:</h4>
      </div>
      <div className="grid">
        <div className="col col-4">
          <label className="star-label" htmlFor="priceScheduleName">
            Schedule:
          </label>
        </div>
        <div className="col col-4">
          <InputText
            id="priceScheduleName"
            {...register("newPriceScheduleName", {
              required: "Price Schedule Name is required",
              maxLength: {
                value: 10,
                message:
                  "Price Schedule Name cannot exceed more than 10 charectors",
              },
            })}
            invalid={errors?.newPriceScheduleName}
            className="star-label uppercase"
          />
          <span className="mandatory-indicator">*</span>
          {errors?.newPriceScheduleName && (
            <div>
              <small id="priceScheduleName-help" className="p-error">
                {errors.newPriceScheduleName.message}
              </small>
            </div>
          )}
        </div>
      </div>
      <div className="grid">
        <div className="col col-4">
          <label className="star-label" htmlFor="priceScheduleDesc">
            Description:
          </label>
        </div>
        <div className="col col-4">
          <InputText
            id="priceScheduleDesc"
            {...register("newPriceScheduleDescription", {
              required: "Price Schedule description is required",
              maxLength: {
                value: 25,
                message:
                  "Price Schedule description cannot exceed more than 10 charectors",
              },
            })}
            invalid={errors?.newPriceScheduleDescription}
            className="star-label uppercase"
          />
          <span className="mandatory-indicator">*</span>
          {errors?.newPriceScheduleDescription && (
            <div>
              <small id="priceScheduleName-help" className="p-error">
                {errors.newPriceScheduleDescription.message}
              </small>
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default CopyPriceSchedule;
